import { cx } from "class-variance-authority";
import { BsQuestionCircleFill } from "react-icons/bs";
import Tooltip from "../tooltip";

export interface FormLabelProps {
  name?: string;
  label?: string;
  required?: boolean;
  tooltip?: string;
  htmlFor?: string;
  unsafeLabelStyling?: string;
}

export const FormLabel = ({
  name,
  label,
  required,
  tooltip,
  unsafeLabelStyling,
  ...props
}: FormLabelProps) => {
  return label ? (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label {...props} className={labelClassName(unsafeLabelStyling, required)}>
      <FormLabelContent label={label} required={required} tooltip={tooltip} />
    </label>
  ) : null;
};

interface FormLabelForNonInteractiveElementProps
  extends Omit<FormLabelProps, "htmlFor"> {
  id: string;
}
export const FormLabelForNonInteractiveElement = (
  props: FormLabelForNonInteractiveElementProps,
) => {
  return props.label ? (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <p
      id={props.id}
      className={labelClassName(props.unsafeLabelStyling, props.required)}
    >
      <FormLabelContent
        label={props.label}
        required={props.required}
        tooltip={props.tooltip}
      />
    </p>
  ) : null;
};

export const labelClassName = (
  unsafeLabelStyling?: string,
  required?: boolean,
) =>
  cx(
    unsafeLabelStyling ?? "text-base flex items-center font-medium",
    required ? "space-x-3" : "space-x-1",
  );

interface FormLabelContentProps {
  label?: string;
  required?: boolean;
  tooltip?: string;
}
export const FormLabelContent = (props: FormLabelContentProps) => {
  return (
    <>
      <span className="relative">
        {props.label ?? name}
        {props.required ? <FormLabelRequiredStar /> : null}
      </span>

      {props.tooltip && props.tooltip !== "" ? (
        <FormLabelTooltip content={props.tooltip} />
      ) : null}
    </>
  );
};

export const FormLabelRequiredStar = () => {
  return <span className="absolute px-[2px] text-ui-red">*</span>;
};

interface FormLabelTooltipProps {
  content: string;
}
export const FormLabelTooltip = (props: FormLabelTooltipProps) => {
  return (
    <Tooltip
      content={props.content}
      className="rounded bg-charcoal px-2 py-1 text-sm text-white"
      side="top"
      arrowClass="text-charcoal"
    >
      <div className="mt-[1px]">
        <BsQuestionCircleFill size={12} />
      </div>
    </Tooltip>
  );
};
